import { belt, BeltColor } from "./BeltColor";

export function getBeltColor(level: number): BeltColor {
  if (level >= belt.length) {
    level = belt.length - 1;
  }
  return belt[level];
}
